import { ActivityGame, GameProvider } from "../game"
import { NavigateFunction } from "react-router-dom"
import { buildRelativeUrl } from "../../../common/utils/web-utils"


export class ArcademicsGameLauncher {

  static launch(game: ActivityGame, navigate: NavigateFunction) {

    if (game.providerId !== GameProvider.ARCADEMICS) {
      console.info(`unexpected game provider id. expected: ${GameProvider.ARCADEMICS}, actual: ${game.providerId}`)
      return
    }
    const params = {
      mode: "self",
      providerId: game.providerId,
      providerGameId: game.providerGameId
    }
    const url = buildRelativeUrl(`/game`, params)
    navigate(url)
  }
}